import { Category, NewProducts, Price } from "../../../../../../constants";
import GenderFilter from "./GenderFilter";
import BrandFilter from "./BrandFilter";
import ColorsFilter from "./ColorsFilter";
import RangeSlider from "./RangeSlider";

// This component renders product filters including category, gender, brand, colors, price, and new products.
const Categories = () => {

  return (
    <>
      <div className="product-filter">
        <h4 className="mb-1">{Category}</h4>
        <GenderFilter />
      </div>
      <BrandFilter />
      <ColorsFilter />
      <div className="product-filter pb-0">
        <h4 className="mb-1">{Price}</h4>
        <RangeSlider />
        <h4 className="mt-5">{NewProducts}</h4>
      </div>
    </>
  );
};

export default Categories;
